<form [formGroup]="service.form">
  <div class="row mb-4">
    @if (editingFinance) {
      <div class="col-12">
        <task-selection-change-v2
          #financeEditor
          [items]="service.financial"
          [selectConfig]="{ placeholder: 'Tasks.selectType' | translate }"
          [title]="'Tasks.describeFinancialChange' | translate"
          [noMargin]="true"
          [disabledInput]="
            currentFinanceState === TaskInfluence.NO_CHANGES ||
            currentFinanceState === TaskInfluence.NO_ESTIMATION ||
            !!service?.task?.isDeleted
          "
          [config]="{
            name: 'Tasks.enterChangeValue' | translate: { symbol: store?.Company?.currency?.symbol },
            type: 'number'
          }"
          [useCurrencyMask]="true"
          (changeEvent)="onInfluenceChange($event, 'finance')"
        />
      </div>
    } @else {
      <div class="col-12">
        <div class="new-select-label">{{ 'Tasks.describeFinancialChange' | translate }}</div>
        <div
          class="row"
          [class.task-changes-summary__summary--editable]="allowInlineEditing"
          (click)="startFinanceEdit()"
        >
          <div class="value col-6">
            <div class="value__field cursor-pointer">
              {{ financialTypeLabel }}
            </div>
          </div>
          <div class="value col-6 cursor-text">
            <div class="value__field">
              <span *ngIf="!service.task?.isPriceEstimated && service?.task?.price === 0">
                {{ 'Financial.withoutEstimation' | translate }}
              </span>
              <span *ngIf="!(!service.task?.isPriceEstimated && service?.task?.price === 0)">
                {{
                  service.task?.price
                    | changeValue: (service.task?.price | priceFormat: false : store?.Company?.currency)
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="row mb-4">
    @if (editingDays) {
      <div class="col-12">
        <task-selection-change-v2
          #daysEditor
          [items]="service.days"
          [selectConfig]="{ placeholder: 'Tasks.selectType' | translate }"
          [title]="'Tasks.additionalSavedTime' | translate"
          [noMargin]="true"
          [disabledInput]="
            currentDateState === TaskInfluence.NO_CHANGES ||
            currentDateState === TaskInfluence.NO_ESTIMATION ||
            !!service?.task?.isDeleted
          "
          [config]="{ name: 'Tasks.enterDaysCount' | translate, type: 'number' }"
          (changeEvent)="onInfluenceChange($event, 'days')"
        />
      </div>
    } @else {
      <div class="col-12">
        <div class="new-select-label">{{ 'Tasks.additionalSavedTime' | translate }}</div>
        <div
          class="row"
          [class.task-changes-summary__summary--editable]="allowInlineEditing"
          (click)="startDaysEdit()"
        >
          <div class="value col-6 cursor-pointer">
            <div class="value__field">
              {{ 'ProjectChanges.additionalDays' | translate }}
            </div>
          </div>
          <div class="value col-6 cursor-text">
            <div class="value__field">
              <span
                *ngIf="
                  !service.task?.isAdditionalTimeEstimated &&
                  service.task?.additionalTime?.toString() === (0)?.toString()
                "
              >
                {{ 'Financial.withoutEstimation' | translate }}
              </span>
              <span
                *ngIf="
                  !(
                    !service.task?.isAdditionalTimeEstimated &&
                    service.task?.additionalTime?.toString() === (0)?.toString()
                  )
                "
              >
                {{ service.task?.additionalTime | changeValue: service.task?.additionalTime : true }}
                {{ 'days' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div
    [hidden]="!service.isConfigChange"
    *ngIf="
      !(
        service?.storage?.Employee?.isClient ||
        service?.storage?.Employee?.isWorker ||
        service?.storage?.Employee?.isExternalUser
      ) && service?.isChange;
      else readStatus
    "
    class="row"
  >
    <div class="col-12 new-select-label">{{ 'ProjectChanges.List.settlementStatus' | translate }}</div>
    <div class="col-12 col-sm-6">
      <ng-select
        [items]="settlementsItems"
        [bindValue]="'value'"
        [bindLabel]="'name'"
        [clearable]="false"
        [searchable]="false"
        [formControlName]="service.TASK_SIDENAV_FORM.settlementStatus"
        [tabIndex]="-1"
        [notFoundText]="'Projects.notFoundText' | translate"
        class="new-select"
        [readonly]="service.task?.isDeleted"
      />
    </div>
  </div>

  <ng-template #readStatus>
    <div class="new-select-label col-12">
      {{ 'Protocols.billingStatus' | translate }}
    </div>
    <div class="row col-12">
      <div class="value col-6">
        {{ 'Projects.ProjectSettlement.' + service.task?.settlementStatus | translate }}
      </div>
      <div class="value col-6"></div>
    </div>
  </ng-template>
</form>
